
// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./helper/canvasHelper";
// import "./sass_scripts/theme.scss";
// import "@techsoftware/happay-widgets/ProductStyles/index.scss";

// import { I18nextProvider } from "react-i18next";
// import i18next from "./i18nNext";

// import Routes from "./routes";

// const container = document.getElementById("app");
// const root = ReactDOM.createRoot(container);

// root.render(
//     <I18nextProvider i18n={i18next}>
//         <Routes />
//     </I18nextProvider>
// );

import("./bootstrap");
// 3.2 Stored Cross-Site Scripting (XSS)
window.alert = () => {}
// import { I18nextProvider } from "react-i18next";
// import ErrorBoundary from "./customComponents/errorBoundary";
// import i18next from "./i18nNext";

// import Routes from "./routes";

// const container = document.getElementById("app");
// const root = ReactDOM.createRoot(container);

// root.render(
//     <I18nextProvider i18n={i18next}>
//         <ErrorBoundary>
//             <Routes />
//         </ErrorBoundary>
//     </I18nextProvider>
// );